var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#061A11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 26.6875H22.375V45.375H13.75C13.3688 45.375 13.0031 45.2236 12.7335 44.954C12.464 44.6844 12.3125 44.3187 12.3125 43.9375V28.125C12.3125 27.7438 12.464 27.3781 12.7335 27.1085C13.0031 26.839 13.3688 26.6875 13.75 26.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 26.6875L29.5625 12.3125C31.0875 12.3125 32.55 12.9183 33.6284 13.9966C34.7067 15.075 35.3125 16.5375 35.3125 18.0625V22.375H46.4352C46.8428 22.374 47.246 22.4602 47.6175 22.6279C47.9891 22.7956 48.3205 23.0409 48.5894 23.3473C48.8583 23.6536 49.0586 24.014 49.1767 24.4042C49.2948 24.7944 49.3281 25.2053 49.2742 25.6094L47.118 42.8594C47.0307 43.5519 46.6946 44.189 46.1722 44.6518C45.6498 45.1147 44.9769 45.3717 44.2789 45.375H22.375",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.4ac3b082d78290033c564c2d1ad575ed.svg";
export { ForwardRef as ReactComponent };